<script lang="ts">
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { sessionStore } from "../../lib/stores/session";
  import { getSelectedLanguageName } from "../../lib/helpers/language";
  import ChevronDown from "../../assets/icons/chevron-down.svg";
  import LanguageSelector from "./LanguageSelector.svelte";
  import { getCopy } from "../../lib/stores/copy";

  let isLanguageSelectorOpen = false;

  const openLanguageSelector = () => isLanguageSelectorOpen = true;
  const closeLanguageSelector = () => isLanguageSelectorOpen = false;

  $: languages = $getCopy("languages", { basePath: "", defaultReturnValue: ["en"] }) as string[];
  $: currentLanguageName = getSelectedLanguageName($sessionStore.language, languages);
</script>

<div class="hidden lg:flex">
  <button class="flex items-center gap-1" on:click={openLanguageSelector}>
    <Typography mobile={TypographyType.Headline5Medium} desktop={TypographyType.Headline5Medium} copy={currentLanguageName} />
    <img src={ChevronDown} class="w-4 h-4" alt="" />
  </button>
  {#if isLanguageSelectorOpen}
    <div class="relative">
      <div
        tabindex={-1}
        role="button"
        class="dropdown absolute z-20 p-2 pt-4 left-1/2 top-14 -translate-x-1/2 bg-white overflow-y-scroll overflow-x-hidden rounded-lg"
        data-testid="dropdown"
        on:click|stopPropagation
        on:keypress|stopPropagation>
        <LanguageSelector onSelect={closeLanguageSelector} />
      </div>
    </div>
  {/if}
  {#if isLanguageSelectorOpen}
    <button class="absolute z-10 top-0 left-0 w-full h-screen bg-transparent" data-testid="transparent-overlay" on:click={closeLanguageSelector}/>
  {/if}
</div>

<style>
  .dropdown {
    width: 18.5rem;
    max-height: 24.25rem;
    box-shadow: 0px 0px 42px 0px rgba(112, 126, 150, 0.16), 0px 0px 9.381px 0px rgba(112, 126, 150, 0.10), 0px 0px 2.793px 0px rgba(112, 126, 150, 0.06);
  }
</style>
